import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f7c4a656"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "req-center" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "req-center__code"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"margin-bottom":"10px"} }, "已驳回", -1))

import { computed, withDefaults } from 'vue';
import {
  BaseButton,
  BaseDialog,
  BaseTextContent,
  BaseInput,
  XrkMessage,
  XrkMessageBox
} from 'xrk-components';
import { PROJECT_CONFIRM_URL } from '@/common/constants/webview/index';
import { letterReject } from '../data-source/apis';


export default /*#__PURE__*/_defineComponent({
  __name: 'confirm-letter-preview',
  props: {
    detailData: {},
    remove: {},
    isAsp: { type: Boolean },
    projectId: {},
    userId: {}
  },
  setup(__props: any) {

const props = __props;

const previewUrl = computed(() => {
  return `${PROJECT_CONFIRM_URL}?projectId=${props.projectId}&userId=${props.userId}`;
});

const isReject = computed(() => {
  return props.detailData.auditStatus === 3;
});

const onClose = () => {
  props.remove?.();
};

const onReject = async () => {
  const data = await XrkMessageBox.prompt('请输入驳回原因', '驳回原因', {
    cancelButtonText: '取消',
    confirmButtonText: '确定',
    inputValidator: val => {
      if (!val) return '请输入驳回原因';
      if (val.length > 50) return '驳回原因不能超过50个字符';
    },
    inputType: 'textarea',
    inputErrorMessage: '请输入驳回原因'
  });

  await letterReject({
    letterId: props.detailData.letterId,
    rejectReason: data.value
  });
  XrkMessage.success('操作成功');
  onClose();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseDialog), { title: "项目信息确认函" }, {
    footer: _withCtx(() => [
      _createVNode(_unref(BaseButton), {
        type: "default",
        onClick: onClose
      }, {
        default: _withCtx(() => [
          _createTextVNode("关闭")
        ]),
        _: 1
      }),
      (_ctx.isAsp && !isReject.value)
        ? (_openBlock(), _createBlock(_unref(BaseButton), {
            key: 0,
            onClick: onReject
          }, {
            default: _withCtx(() => [
              _createTextVNode("驳回")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(BaseTextContent), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
              class: "req-center__phone",
              style: _normalizeStyle({ left: isReject.value ? 0 : 'calc(50% - 150px)' })
            }, [
              _createElementVNode("iframe", {
                ref: "iframeRef",
                src: previewUrl.value,
                frameborder: "0",
                width: "375px",
                height: "670px"
              }, null, 8, _hoisted_2)
            ], 4),
            (isReject.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _hoisted_4,
                  _createVNode(_unref(BaseInput), {
                    style: {"width":"300px"},
                    type: "textarea",
                    rows: 10,
                    disabled: "",
                    "model-value": _ctx.detailData.rejectReson
                  }, null, 8, ["model-value"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})